import { render } from "./skudetail.vue?vue&type=template&id=312325e3"
import script from "./skudetail.vue?vue&type=script&lang=js"
export * from "./skudetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__